var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:`d-flex flex-row justify-content-center align-items-center GSE-button-medium mt-1 ${
        _vm.isFavorite
            ? 'btn-primary'
            : 'GSE-button-secondary GSE-color-border-lighter GSE-color-text-primary GSE-color-border-darker '
    }`,staticStyle:{"width":"max-content"},attrs:{"type":"button","title":_vm.isFavorite ? 'Remove From My Favorites' : 'Add To My Favorites'},on:{"click":function($event){$event.stopPropagation();return _vm.event.apply(null, arguments)}}},[_c('i',{staticClass:"dripicons-heart",class:{ filledHeart: _vm.isFavorite }})])
}
var staticRenderFns = []

export { render, staticRenderFns }